import { Password } from "primereact/password";
import * as React from "react";
import "./PrwPassword.scss";

const PrwPassword = (props: any) => {
  const { options } = props;
  const showFeedback = options['showFeedback'] ?? false;

  return (
    <div>
      <Password
      feedback={showFeedback}
        className={`p-inputtext-sm p-d-block ${
          props?.rawErrors?.length > 0 ? "p-invalid" : null
        }`}
        value={props.value || ""}
        onChange={(e: any) => props.onChange(e.target.value)}
      />
    </div>
  );
};

export default PrwPassword;
